module.exports = __webpack_public_path__ + "static/videopagarEN-80399f30037410707064681c777827d1.png";